"use client";
import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { cn as l, dataAttr as r } from "../../utils.js";
import { skeleton as a } from "../../ui/recipes/skeleton.js";
import { useInkeepConfig as c } from "@inkeep/cxkit-primitives";
function p() {
  const {
    searchSettings: { tabs: i }
  } = c();
  return /* @__PURE__ */ s("div", { className: "flex flex-col h-full", children: [
    /* @__PURE__ */ s("div", { className: l("h-[calc(100%-24px)]"), children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: "flex px-5 py-1 gap-3 data-[hidden]:hidden",
          "data-hidden": r(i.length === 0),
          children: Array.from({ length: 2 }).map((n, d) => /* @__PURE__ */ e("div", { className: l(a(), "h-[27.88px] w-16 rounded-full") }, d))
        }
      ),
      /* @__PURE__ */ s("div", { className: "flex px-5 py-1 gap-5 h-full", children: [
        /* @__PURE__ */ e("div", { className: "flex flex-col flex-1 [[data-view=dual-pane]_&]:flex-[0_0_40%]", children: Array.from({ length: 4 }).map((n, d) => /* @__PURE__ */ e("div", { className: "flex items-center pb-2.5 w-full", children: /* @__PURE__ */ e("div", { className: l(a(), "h-20 rounded-lg grow-[1]") }) }, d)) }),
        /* @__PURE__ */ e(
          "div",
          {
            className: l(
              a(),
              "h-full w-full rounded-md",
              "hidden [[data-view=dual-pane]_&]:block"
            )
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e("div", { className: "flex pt-1 pb-3 px-5 justify-self-end", children: /* @__PURE__ */ e("div", { className: l(a(), "h-[24px] w-40 rounded-md") }) })
  ] });
}
export {
  p as ResultsLoading
};
